import { fromIsoString, toIsoString } from '../chat/iso-date';
import type { WorkflowCronTriggerData } from './types';
import type { SerializedWorkflowCronTrigger } from './types';
import { WorkflowTrigger } from './workflow-trigger';
import type { WorkflowTriggerHydration } from './workflow-trigger';

/**
 * Standalone cron trigger (`workflow_triggers_cron`).
 */
export class WorkflowCronTrigger extends WorkflowTrigger<WorkflowCronTriggerData> {
  readonly kind = 'cron' as const;

  private constructor(
    data: WorkflowCronTriggerData,
    hydration?: WorkflowTriggerHydration
  ) {
    super(data, hydration);
  }

  get cron(): string {
    return this._data.cron;
  }

  get name(): string {
    return this._data.name;
  }

  get timezone(): string {
    return this._data.timezone;
  }

  get workflowInput(): unknown {
    return this._data.workflowInput;
  }

  get cronTriggerData(): WorkflowCronTriggerData {
    return { ...this._data };
  }

  serialize(): SerializedWorkflowCronTrigger {
    return {
      id: this._data.id,
      ownerId: this._data.ownerId,
      ownerOrgId: this._data.ownerOrgId,
      name: this._data.name,
      cron: this._data.cron,
      timezone: this._data.timezone,
      workflowInput: this._data.workflowInput,
      enabled: this._data.enabled,
      createdAt: toIsoString(this._data.createdAt),
      updatedAt: toIsoString(this._data.updatedAt),
    };
  }

  static fromSerialized(
    serialized: SerializedWorkflowCronTrigger,
    hydration?: WorkflowTriggerHydration
  ): WorkflowCronTrigger {
    const data: WorkflowCronTriggerData = {
      id: serialized.id,
      ownerId: serialized.ownerId,
      ownerOrgId: serialized.ownerOrgId,
      name: serialized.name,
      cron: serialized.cron,
      timezone: serialized.timezone,
      workflowInput: serialized.workflowInput,
      enabled: serialized.enabled,
      createdAt: fromIsoString(serialized.createdAt),
      updatedAt: fromIsoString(serialized.updatedAt),
    };
    return new WorkflowCronTrigger(data, hydration);
  }
}
